import Container from '../components/Container';
import { SuperAdminHeader } from '../components/SuperAdminHeader';

import Card from '../components/Card';
// import { LoadingPage } from '../components/Loading';

// import * as portalApi from '../utils/api';

export default function SuperAdminDashboard() {
  return (
    <Container>
      <SuperAdminHeader />

      <Card className="relative px-6 py-8 mb-8 overflow-x-auto md:py-12 md:px-10">
        Hi Super Admin! We will put more interesting stuff in here in the future.
      </Card>
    </Container>
  );
}
